import React from 'react';

export const Pending = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.992 0C3.576 0 0 3.584 0 8C0 12.416 3.576 16 7.992 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 7.992 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4ZM8.4 4H7.2V8.8L11.4 11.32L12 10.336L8.4 8.2V4Z"
        fill="#666666"
      />
    </svg>
  );
};
export const Cancel = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.072 4.8L8 6.872L5.928 4.8L4.8 5.928L6.872 8L4.8 10.072L5.928 11.2L8 9.128L10.072 11.2L11.2 10.072L9.128 8L11.2 5.928L10.072 4.8ZM8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4Z"
        fill="#666666"
      />
    </svg>
  );
};

export const BalanceIcon = ({ fill = '#2F6FA7' }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.43701 4.33333C6.43701 3.96533 6.73568 3.66667 7.10368 3.66667C7.47168 3.66667 7.77035 3.96533 7.77035 4.33333C7.77035 4.70133 7.47168 5 7.10368 5C6.73568 5 6.43701 4.70133 6.43701 4.33333ZM6.43701 6.33333C6.43701 5.96533 6.73568 5.66667 7.10368 5.66667C7.47168 5.66667 7.77035 5.96533 7.77035 6.33333V9.66667C7.77035 10.0347 7.47168 10.3333 7.10368 10.3333C6.73568 10.3333 6.43701 10.0347 6.43701 9.66667V6.33333ZM7.10368 12.3333C4.16301 12.3333 1.77035 9.94067 1.77035 7C1.77035 4.05933 4.16301 1.66667 7.10368 1.66667C10.0443 1.66667 12.437 4.05933 12.437 7C12.437 9.94067 10.0443 12.3333 7.10368 12.3333ZM7.10368 0.333332C3.42168 0.333332 0.437012 3.318 0.437012 7C0.437012 10.682 3.42168 13.6667 7.10368 13.6667C10.785 13.6667 13.7703 10.682 13.7703 7C13.7703 3.318 10.785 0.333332 7.10368 0.333332Z"
        fill={fill}
      />
    </svg>
  );
};

export const ForeignTransIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.5C7.47 2.5 3 6.97 3 12.5C3 18.03 7.47 22.5 13 22.5C18.53 22.5 23 18.03 23 12.5C23 6.97 18.53 2.5 13 2.5ZM13 20.5C8.59 20.5 5 16.91 5 12.5C5 8.09 8.59 4.5 13 4.5C17.41 4.5 21 8.09 21 12.5C21 16.91 17.41 20.5 13 20.5Z"
        fill="#666666"
      />
      <path
        d="M7 15.5V9.5H11.3711V10.8971H8.82774V12.053H11.1297V13.3753H8.82774V15.5H7Z"
        fill="#666666"
      />
      <path
        d="M12.8529 15.5L14.685 12.4938V12.4605L12.8486 9.5H14.9781L15.9566 11.4127H15.9911L16.974 9.5H19L17.0731 12.4688V12.5021L18.9914 15.5H16.9567L15.8834 13.6913H15.8489L14.7841 15.5H12.8529Z"
        fill="#666666"
      />
      <rect x="10" y="4.5" width="2" height="3" fill="#666666" />
      <rect x="14" y="4.5" width="2" height="3" fill="#666666" />
      <rect
        x="21"
        y="6.5"
        width="2"
        height="15"
        transform="rotate(90 21 6.5)"
        fill="#666666"
      />
      <rect
        x="21"
        y="16.5"
        width="2"
        height="16"
        transform="rotate(90 21 16.5)"
        fill="#666666"
      />
      <rect x="10" y="17.5" width="2" height="3" fill="#666666" />
      <rect x="14" y="17.5" width="2" height="3" fill="#666666" />
    </svg>
  );
};
